import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const isSmoker: AnswerPathTreeNode = { path: 'isSmoker', nodeId: NodeIds.insuredIsTobaccoUser };
